import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

@Component({
    selector: 'app-color-box',
    styleUrls: ['./app.color.box.component.scss'],
    templateUrl: './app.color.box.component.html',
})
export class AppColorBoxComponent implements OnChanges {

    constructor(

    ) { }

    @Input() color:string ='';

    currentColor ='';

    ngOnChanges(changes: SimpleChanges): void {

        if(changes.color && changes.color.currentValue){
            this.currentColor = changes.color.currentValue;
        }

    }
}
